<script>
    import {onMount} from "svelte";

    onMount(() => {
        // Redirect to the listings page
        window.location.href = 'https://app.bizzer.ai';
    });
</script>